import React from 'react';
import Troubleshooting from '@/pages/Troubleshooting';

const TroubleshootingSoftware = () => {
  return (
    <div className="space-y-6" data-testid="troubleshooting-software-page">
      <div className="panel-header">
        <div>
          <div className="panel-title">Troubleshooting / Software</div>
          <h1 className="text-3xl md:text-4xl font-semibold tracking-tight mt-2">Software &amp; Workflow Wizard</h1>
          <p className="text-sm md:text-base text-[var(--text-secondary)] mt-2 max-w-2xl">
            Focus on toolpaths, CAM settings, post-processors, and job setup issues. Uses the same
            troubleshooting knowledge base, viewed through a software lens.
          </p>
        </div>
      </div>
      <Troubleshooting />
    </div>
  );
};

export default TroubleshootingSoftware;
